/**
 * @file Route: resources
 *
 * This file is compiled as a standalone entrypoint and it is included by
 * default in its blade template.
 * This is a "standard" route, it does not have a structure to follow, you are
 * sure the DOM is always ready and the JS will only be executed in this route.
 */

import "layouts/main";
import { $all, forEach, on } from "@olmokit/dom";
import { dataLayerDowload } from "components/Datalayer"
import zacc from "@olmokit/core/zacc/withCheckbox";
import { Header } from "components/Header/Info";
import "./index.scss";

console.log("Route resources/index.js mounted.");

Header();

forEach($all("[download]"), el => {
  on(el, 'click', () => {
    const title = el.getAttribute('title')
    const collection = el.getAttribute('collection')
    const action = el.getAttribute('action')
    dataLayerDowload(collection, title, action)
  })
});

forEach($all(".list:multiple"), $list => {
  zacc($list, { duration: 300 });
});